"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _headerPropTypeValidation = _interopRequireDefault(require("../../utils/headerPropTypeValidation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Theatre = _ref => {
  let {
    className,
    prefix,
    children,
    open,
    closeBtnClick,
    header,
    ...other
  } = _ref;
  const classes = (0, _classnames.default)(`${prefix}theatre`, open ? `${prefix}theatre--enter` : `${prefix}theatre--close`, className);
  const hookedHeader = header ? _react.default.cloneElement(header, {
    closeBtnClick,
    prefix
  }) : null;
  const hookedBody = _react.default.Children.map(children, child => child.props ? _react.default.cloneElement(child, {
    prefix
  }) : child);
  return _react.default.createElement("div", _extends({}, other, {
    className: classes,
    "aria-modal": "true",
    role: "dialog",
    tabIndex: "-1"
  }), _react.default.createElement("div", {
    className: `${prefix}theatre__content-wrapper`
  }, hookedHeader, hookedBody));
};
Theatre.defaultProps = {
  open: false,
  prefix: ''
};
var _default = Theatre;
exports.default = _default;